/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Ups_Rebook_TitleInputs */

const en_orders_ups_rebook_title = /** @type {(inputs: Orders_Ups_Rebook_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebook UPS Shipments?`)
};

const es_orders_ups_rebook_title = /** @type {(inputs: Orders_Ups_Rebook_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a reservar envios UPS?`)
};

/**
* | output |
* | --- |
* | "Rebook UPS Shipments?" |
*
* @param {Orders_Ups_Rebook_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_ups_rebook_title = /** @type {((inputs?: Orders_Ups_Rebook_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Ups_Rebook_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_ups_rebook_title(inputs)
	return es_orders_ups_rebook_title(inputs)
});